import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@beweegbaas/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ImportHintAlert } from "#/modules/school.import/components/import-hint-alert";
import { EditStudentForm } from "#/modules/school.students/components/edit-student-form";
import { getStudentModalData } from "#/modules/school.students/students.functions";

// Add-student modal (portal's `students.overview.modal`), rendered over the overview table.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/students/overview/modal",
)({
  loader: () => getStudentModalData({ data: {} }),
  component: AddStudentModal,
});

function AddStudentModal() {
  const navigate = useNavigate();
  const { klassen } = Route.useLoaderData();
  const { locale, schoolyear, school } = Route.useParams();
  // Close back to the overview table.
  const onClose = () =>
    navigate({
      to: "/$locale/{-$schoolyear}/$school/students/overview",
      params: { locale, schoolyear, school },
      search: (prev) => prev,
      replace: true,
    });

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) void onClose();
      }}
    >
      <DialogContent className="md:max-w-lg!" showCloseButton>
        <DialogHeader>
          <DialogTitle>Leerling toevoegen</DialogTitle>
        </DialogHeader>
        <ImportHintAlert />
        <EditStudentForm student={null} klassen={klassen} onSuccess={onClose} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  );
}
